import { useEffect, useRef, useState } from "react";
import "./insights.css";
import { useNavigate } from "react-router-dom";
import { collection, onSnapshot, query, orderBy, limit } from "firebase/firestore";
import { db } from "../firebase/config";

export default function AcademicInsights() {

  const sliderRef = useRef(null);
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);

  // ================= 🔥 LOAD BLOGS =================
  useEffect(() => {

    // CACHE FIRST (instant UI)
    const cached = localStorage.getItem("blogsData");
    if (cached) {
      try {
        setBlogs(JSON.parse(cached).slice(0, 3));
      } catch {}
    }

    // FIRESTORE (latest 3)
    const q = query(
      collection(db, "blogs"),
      orderBy("date", "desc"),
      limit(3)
    );

    const unsub = onSnapshot(q, (snap) => {
      const data = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      setBlogs(data);

      // store full list (not just 3)
      localStorage.setItem("blogsData", JSON.stringify(data));
    });

    return () => unsub();
  }, []);

  // ================= 🔥 AUTO SLIDER =================
  useEffect(() => {
    const container = sliderRef.current;
    if (!container) return;

    let scrollAmount = 0;

    const interval = setInterval(() => {
      if (window.innerWidth <= 768) {

        const card = container.querySelector(".insight-card");
        if (!card) return;

        const gap = 16;
        const cardWidth = card.offsetWidth + gap;

        const maxScroll = container.scrollWidth - container.clientWidth;

        scrollAmount += cardWidth;

        if (scrollAmount >= maxScroll) {
          scrollAmount = maxScroll;

          container.scrollTo({
            left: scrollAmount,
            behavior: "smooth"
          });

          setTimeout(() => {
            scrollAmount = 0;
            container.scrollLeft = 0;
          }, 800);

        } else {
          container.scrollTo({
            left: scrollAmount,
            behavior: "smooth"
          });
        }
      }
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="insights">
      <div className="insights-container">

        {/* HEADER */}
        <div className="insights-header">
          <div>
            <h2>Academic Insights</h2>
            <p>Reflections on literature and education</p>
          </div>

          <button
            className="view-all-btn"
            onClick={() => navigate("/blogs")}
          >
            View all stories →
          </button>
        </div>

        {/* GRID / SLIDER */}
        <div className="insights-grid" ref={sliderRef}>
          {blogs.map((blog) => (
            <div key={blog.id} className="insight-card">

              <img src={blog.img} alt={blog.title} />

              <div className="insight-content">
                <span className="date">{blog.date}</span>

                <h4>{blog.title}</h4>

                <p>{blog.desc}</p>

                <button
                  className="read-more"
                  onClick={() => navigate(`/blog/${blog.id}`)}
                >
                  READ MORE →
                </button>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}